import { createFileRoute } from '@tanstack/react-router'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { ReapproCategoriesPanel } from '~/components/routes/categories/ReapproCategoriesPannel'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/reappro/')({
  staticData: {
    permission: ['read', 'categories'],
  },
  component: ReapproCategoriesTabPage,
})
withRoutePermissions(Route)

function ReapproCategoriesTabPage() {
  return (
    <CategoriesPageLayout activeTab="reappro">
      <ReapproCategoriesPanel />
    </CategoriesPageLayout>
  )
}
